export default {
  SQUARE: 'square_popup',
  LOYALTY: 'loyalty_popup'
};

export const HIDE_ALERT_MODALS_SESSION_KEY = 'HIDE_ALERT_MODALS';
